<!--
 * @Name: systemType
 * @Description: 系统类别
 * @Author: xiadongxue
 * @Date: 2022-04-13 15:49:05
 * @Editors: xiadongxue
-->
<template>
<div
    class="system-category-wrap"
    v-loading="tableLoading">
    <div class="header-icon">
        <div
            class="click-icon add_icon"
            @click="visible = true"></div>
        <div
            class="click-icon refresh_icon"
            @click="refresh"></div>
    </div>
    <el-table
        :data="list"
        style="width: 100%"
        stripe
        border>
        <el-table-column
            v-for="item in tableColumn"
            :key="item.prop"
            align="center"
            :prop="item.prop"
            :label="item.label" />
        <el-table-column
            label="操作"
            align="center"
            width="120">
            <template v-slot="{row}">
                <el-button
                    type="text"
                    @click="editProject(row)">编辑</el-button>
                <!--
                    <el-button
                        type="text"
                        @click="delProject(row.categoryId)">删除</el-button>
                --> 
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        v-loading="loading"
        class="system-category-dialog"
        title="类别信息"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @close="close"
        width="600px">
        <el-form
            label-width="170px"
            ref="form"
            :model="categoryData"
            :rules="categoryRules">
            <el-form-item
                prop="categoryName"
                label="类别名称">
                <el-input
                    v-model="categoryData.categoryName"
                    size="small" />
            </el-form-item>
            <el-form-item
                prop="categoryDesc"
                label="类别描述">
                <el-input
                    type="textarea"
                    v-model="categoryData.categoryDesc"
                    size="small" />
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="close"
                size="small">取消</el-button>
            <el-button
                @click="toSubmit"
                size="small"
                type="danger">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    getCategoryList,
    addCategory,
    editCategory,
    delCategory
} from './api';
export default {
    name: 'categoryList',
    data() {
        return {
            loading: false,
            //编辑弹窗
            visible: false,
            //类别id
            categoryId: '',
            //展示弹窗数据
            categoryData: {},
            //默认弹窗数据
            defaultData: {
                categoryName: '',
                categoryDesc: ''
            },
            //表格数据
            list: [],
            tableColumn: [{
                    prop: 'categoryName',
                    label: '类别名称',
                },
                {
                    prop: 'categoryDesc',
                    label: '类别描述',
                }
            ],
            categoryRules: {
                categoryName: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }, ],
                categoryDesc: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }]
            },
        };
    },
    created() {
        this.toSearch();
    },
    methods: {
        //点击查询
        async toSearch() {
            try {
                this.tableLoading = true;
                let {
                    code,
                    result
                } = await getCategoryList();
                if (code === 0) {
                    this.list = result;
                }
                this.tableLoading = false;
            } catch (error) {
                this.tableLoading = false;
                console.log(error);
            }
        },
        //重置
        refresh() {
            this.toSearch();
        },
        //编辑
        editProject(row) {
            this.categoryId = row.categoryId;
            this.categoryData = Object.assign({},row);
            this.visible = true;
        },
        //删除
        async delProject(categoryId) {
            try {
                let res = await this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                });
                if (res) {
                    let {
                        code
                    } = await delCategory({
                        categoryId
                    });
                    if (code === 0) {
                        this.toSearch();
                        this.$message.success('删除成功');
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        //弹窗关闭
        close() {
            this.visible = false;
            this.categoryData = JSON.parse(JSON.stringify(this.defaultData));
            this.categoryId = '';
            this.$nextTick(this.$refs['form'].clearValidate);
        },
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave();
                } else {
                    return false;
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true;
                let Fn = addCategory;
                let data = {
                    categoryName: this.categoryData.categoryName,
                    categoryDesc: this.categoryData.categoryDesc
                };
                if (this.categoryId) {
                    Fn = editCategory;
                    data.categoryId = this.categoryId;
                }
                let {
                    code
                } = await Fn(data);
                if (code === 0) {
                    this.$message.success(`${(this.categoryId) ? '修改' : '添加'}成功`);
                    this.toSearch();
                    this.close();
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss">
.system-category-dialog {

    .el-input,
    .el-select,
    .el-textarea {
        width: 300px;
    }
}
</style>

